// web_circuit_line_editor 若旅游产品已关联该线路，未单独设置产品附加金额，编辑保存时需更新与之关联的产品的附加金额信息

const __request = require(`@/lib/data-service/default/__request/__request_contentType_form`);

// 接口地址：http://192.168.0.15:8080/doc.html#/所有接口/circuit-operate-controller/updateBindingLineUsingPOST

export default function web_circuit_line_editor(pParameter) {
  if (!pParameter) pParameter = {};
  /*const supplierId = pParameter.supplierId || ''
  const lineId = pParameter.lineId || ''
  const lineName = pParameter.lineName || ''
  const lineType = pParameter.lineType || ''
  const attachType = pParameter.attachType || ''
  const attachAmountType = pParameter.attachAmountType || ''
  const attachAdultAmount = pParameter.attachAdultAmount || ''
  const attachChildAmount = pParameter.attachChildAmount || ''
  const isDelete = pParameter.isDelete || 0
  const attachChildBedAmount = pParameter.attachChildBedAmount || ''
  const attachAgedAmount = pParameter.attachAgedAmount || ''
  const attachAdultPercent = pParameter.attachAdultPercent || ''
  const attachChildPercent = pParameter.attachChildPercent || ''
  const attachChildBedPercent = pParameter.attachChildBedPercent || ''
  const attachAgedPercent = pParameter.attachAgedPercent || ''
  const serviceFeeType = pParameter.serviceFeeType === undefined ? '' : pParameter.serviceFeeType
  const serviceFeePercent = pParameter.serviceFeePercent || ''*/
  let params = {}
  params.method = 'POST'
  params.urlSuffix = '/web/circuit/line/editor'
  params.data = pParameter
  /*params.data = {
    supplierId,
    lineId,
    lineName,
    lineType,
    attachType,
    attachAmountType,
    attachAdultAmount,
    attachChildAmount,
    isDelete,
    attachChildBedAmount,
    attachAgedAmount,
    attachAdultPercent,
    attachChildPercent,
    attachChildBedPercent,
    attachAgedPercent,
    serviceFeeType,
    serviceFeePercent
  }*/
  return new Promise(function (resolve, reject) {
    resolve(__request(params))
  })
}
